import { Component, EventEmitter, Input, Output, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'table-filters',
    templateUrl: './table-filters.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TableFiltersComponent),
            multi: true,
        },
    ],
})
export class TableFiltersComponent implements OnInit, ControlValueAccessor {
    @Input() filters: any;
    @Input() open: boolean = false;
    @Input() selectorItemTemplate?: any;
    @Output() onChanges = new EventEmitter<any>();
    @Output() openChange = new EventEmitter<boolean>();

    showDropdown: boolean = true;
    model: any = {};

    private _value: any = {};
    private _onChange = (value: any) => {};
    private _onTouched = () => {};

    ngOnInit () {
        this.model = this.model || {};
        this.open = this.open || false;
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            this._value = val;
            this.model = val;
            this._onChange(val);
            this._onTouched();
        }
    }

    // ControlValueAccessor implementation
    writeValue (value: any): void {
        if (value !== undefined && value !== null) {
            this._value = value;
            this.model = value;
        }
    }

    registerOnChange (fn: (value: any) => void): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: () => void): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        // Implementation can be added if needed for disabled state
    }

    clear () {
        const emptyModel = this.emptyModelData();
        this.value = emptyModel; // Use the setter to trigger change events
        this.model = emptyModel;
        this.onChanges.emit(emptyModel);
        this.open = false;
        this.openChange.emit(this.open);
    }

    toggleSelector () {
        this.showDropdown = !this.showDropdown;
    }

    private emptyModelData () {
        const result: any = {};
        for (const key in this.model) {
            if (this.model.hasOwnProperty(key)) {
                result[key] = [];
            }
        }
        return result;
    }

    onFiltersChange (event: any) {
        this.onChanges.emit((event).changes);
    }

    onShowDropdownChange (showDropdown: boolean) {
        this.showDropdown = showDropdown;
    }
}
